module.exports = __webpack_public_path__ + "media/images/metronic/sidebar-toggle-light-553f66ee06a1727c9a849c9ba03540cc.png";